import __times from 'lodash/times'
import __uniqueId from 'lodash/uniqueId'
import styled from 'styled-components'

import { Typography } from '@components/ui/Typography'

import { Currency } from '../../FormattedTexts'
import { MoneyBagIcon } from '../../svgIcons'

const CalculatorItemDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 0;
`

const ValueContainerDiv = styled.div.withConfig<{ isDemo?: boolean }>({
  shouldForwardProp: (prop, defaultValidator) => {
    return !['isDemo'].includes(prop) && defaultValidator(prop)
  },
})`
  min-width: 126px;
  height: 48px;
  padding: 10px 18px;
  border-radius: 8px;
  border-width: 2px;
  border-style: solid;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme, isDemo }) => (isDemo ? theme.colors.blue[40] : theme.colors.primary[50])};
  border-color: ${({ theme, isDemo }) => (isDemo ? theme.colors.common.demoBlue : theme.colors.primary[140])};
`

export interface CalculatorItemProps {
  isDemo?: boolean
  label: StringOrMessage
  value: number
}

export default function CalculatorItem({ isDemo = false, label, value }: CalculatorItemProps) {
  const itemId = __uniqueId('calculator-item-')
  return (
    <CalculatorItemDiv>
      <ValueContainerDiv isDemo={isDemo} aria-labelledby={itemId}>
        {isDemo ? __times(value, index => <MoneyBagIcon key={index} />) : <Currency value={value} />}
      </ValueContainerDiv>
      <Typography id={itemId} color="gray-80" size="400-xs" tag="span" align="center">
        {label}
      </Typography>
    </CalculatorItemDiv>
  )
}
